import React from 'react';
import {Link} from 'react-router';
import type {LocationDescriptor} from 'lib/router/types';
import {StudyGuideItem} from 'client/generic/StudyGuideItem/StudyGuideItem.react';
import MarkdownRendererV2 from 'generic/MarkdownRendererV2/MarkdownRendererV2.react';
import FreeResponseQuestionSubTypeBadge from 'client/FreeResponseQuestion/FreeResponseQuestionSubTypeBadge/FreeResponseQuestionSubTypeBadge';
import type {QuestionModelV3} from '@albert-io/models';
import type {QuestionSetModelV1} from 'resources/augmented/QuestionSet/QuestionSetModel.v1';
import type {GuideLevelModelV2} from 'resources/augmented/GuideLevel/GuideLevelModel.v2';
import ActionsDropdown from 'client/generic/StudyGuideItem/Teacher/ActionsDropdown/ActionsDropdown.react';

interface Props {
  className?: string | null;
  question: QuestionModelV3;
  to?: LocationDescriptor | null;
  heading?: string;
  questionSetIds?: string[];
  hasAssignAccess?: boolean;
  guideLevel?: GuideLevelModelV2;
  questionSet?: QuestionSetModelV1;
  usePublicView?: boolean;
  onClick?: (event: React.MouseEvent) => void;
}

const FRQQuestionItem = ({
  className,
  question,
  to,
  heading = 'h1',
  questionSetIds,
  hasAssignAccess,
  guideLevel,
  questionSet,
  usePublicView,
  onClick
}: Props) => {
  const dropdownLink = typeof to === 'string' ? to : to?.pathname;
  // Null `to` = locked question (#19056); render unlinked.
  const wrapperProps = to ? {as: Link, to, onClick} : {onClick};

  return (
    <StudyGuideItem
      aria-label={question.getTitle()}
      className={className}
      itemType='question'
      {...wrapperProps}
    >
      <StudyGuideItem.Content>
        <StudyGuideItem.Heading as={heading}>
          <MarkdownRendererV2 text={question.getTitle()} />
        </StudyGuideItem.Heading>
        {!usePublicView && (
          <StudyGuideItem.Meta className='frq-item__metadata'>
            <FreeResponseQuestionSubTypeBadge question={question} />
          </StudyGuideItem.Meta>
        )}
      </StudyGuideItem.Content>
      {hasAssignAccess && (
        <ActionsDropdown
          guideLevel={guideLevel}
          buttonClassName='study-guide-actions-dropdown__btn unbutton'
          className='study-guide-actions-dropdown'
          questionSetIds={questionSetIds}
          questionCount={1}
          questionSet={questionSet}
          link={dropdownLink}
        />
      )}
    </StudyGuideItem>
  );
};

export default FRQQuestionItem;
